var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.album-delete{fill:#f61509;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "album-delete",
    d: "M304 900q-27.75 0-47.375-19.625T237 833V325h-40v-35h158v-29h251v29h158v35h-40v508q0 27.5-19.75 47.25T657 900H304Zm385-575H272v508q0 14 9.5 23t22.5 9h353q12 0 22-10t10-22V325ZM394 782h35V406h-35v376Zm139 0h35V406h-35v376ZM272 325v540-540Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b68c317455bff981065645a5e7c2de00.svg";
export { ForwardRef as ReactComponent };